module.exports = __webpack_public_path__ + "static/media/Wsparcie_sprzedazy_1_B.46227f75.png";